import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {userHasStaffAccessSelector} from "../../../selectors/userSelectors";
import routes from "../../../routes";
import popupBalloonStyles from '../../Shared/PopupBalloon.module.scss';
import {faBoxesStacked, faCertificate, faCog, faFileAlt, faSignOutAlt} from "@fortawesome/free-solid-svg-icons";
import Icon from "../../Shared/Icon";
import sessionService from "../../../services/sessionService";
import userActions from "../../../actions/userActions";
import {useHistory} from "react-router-dom";
import classNames from "classnames";

const SettingsMenu = ({
  close = () => {}, styles = {}
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userHasStaffAccess = useSelector(userHasStaffAccessSelector);

  const handleChangelog = () => {
    close();
    alert('Coming soon...');
  };

  const handleSettings = () => {
    close();
    history.push(routes.settings.path);
  };

  const handleLogout = () => {
    close();
    sessionService.destroy().then(() => dispatch(userActions.set(false)));
  };

  const handleClick = (path) => {
    close();
    window.open(path, '_blank');
  }

  return (
    <>
    {userHasStaffAccess && (
        <>
          <div
            onClick={() => handleClick(routes.staff.path)}
            className={classNames(popupBalloonStyles.popupBalloonLink, styles.link)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className={classNames(popupBalloonStyles.popupBalloonLinkIcon, styles.icon)}>
              <Icon use={faCertificate} classes="small" />
            </div>
            <div className={classNames(popupBalloonStyles.popupBalloonLinkText, styles.text)}>
              Administration
            </div>
          </div>
          <div
            onClick={() => handleClick(routes.sidekiq.path)}
            className={classNames(popupBalloonStyles.popupBalloonLink, styles.link)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className={classNames(popupBalloonStyles.popupBalloonLinkIcon, styles.icon)}>
              <Icon use={faBoxesStacked} classes="small" />
            </div>
            <div className={classNames(popupBalloonStyles.popupBalloonLinkText, styles.text)}>
              Sidekiq Monitor
            </div>
          </div>
        </>
      )}
      <div
        onClick={handleChangelog}
        className={classNames(popupBalloonStyles.popupBalloonLink, styles.link)}
      >
        <div className={classNames(popupBalloonStyles.popupBalloonLinkIcon, styles.icon)}>
          <Icon use={faFileAlt} classes="small" />
        </div>
        <div className={classNames(popupBalloonStyles.popupBalloonLinkText, styles.text)}>
          Changelog
        </div>
      </div>
      <div
        onClick={handleSettings}
        className={classNames(popupBalloonStyles.popupBalloonLink, styles.link)}
      >
        <div className={classNames(popupBalloonStyles.popupBalloonLinkIcon, styles.icon)}>
          <Icon use={faCog} classes="small" />
        </div>
        <div className={classNames(popupBalloonStyles.popupBalloonLinkText, styles.text)}>
          Settings
        </div>
      </div>
      <div
        onClick={handleLogout}
        className={classNames(popupBalloonStyles.popupBalloonLink, styles.link)}
      >
        <div className={classNames(popupBalloonStyles.popupBalloonLinkIcon, styles.icon)}>
          <Icon use={faSignOutAlt} classes="small" />
        </div>
        <div className={classNames(popupBalloonStyles.popupBalloonLinkText, styles.text)}>
          Logout
        </div>
      </div>
    </>
  )
}


export default SettingsMenu;
